import { ApiMethodDeclaration } from '..';

type ParamsData = {
    id: number;
    status: 'ok' | 'bad';
};

type ResponseData = {
    id: number;
    status: 'new' | 'ok' | 'bad';
};

export const setStatus: ApiMethodDeclaration<ParamsData, ResponseData> = ({ id, status }) => ({
    url: `/admin/content-reviews/${id}`,
    method: 'PATCH',
    data: { status },
});
